import React, { useState, useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Modal, Form } from "react-bootstrap";
import SubmitButton from "../UIComponents/SubmitButton";

import exportToPdf from "../../lib/exportToPdf";
import exportToPdfReport from "../../lib/exportToPdfReport";

const ModalPdf = ({
  isReport,
  show,
  handleClose,
  chart,
  data,
  anotherDataForComparasion,
  additionalNotes,
  days,
}) => {
  const [withoutNote, setWithoutNote] = useState(false);
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("exportreport.header")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {`${t("exportreport.body.0")} ${days} ${t("exportreport.body.1")}`}
        </p>
        <Form.Check
          name="withoutNote"
          type="checkbox"
          label={t("exportreport.exclude_symptoms")}
          checked={withoutNote}
          style={{ fontWeight: "400", fontSize: "small" }}
          onChange={() => setWithoutNote(!withoutNote)}
        />
      </Modal.Body>
      <Modal.Footer>
        <SubmitButton
          onClick={() => {
            isReport
              ? exportToPdfReport(
                  chart,
                  data,
                  days,
                  anotherDataForComparasion,
                  additionalNotes,
                  patient,
                  withoutNote
                )
              : exportToPdf(
                  chart,
                  data,
                  days,
                  additionalNotes,
                  patient,
                  withoutNote
                );
            handleClose();
          }}
        >
          {t("exportreport.button")}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPdf;